"use client";

import AppRoutes from "@/app/constants/routes";
import { useTncCheckbox } from "@/app/hooks/useTncCheckbox";
import CustomButtonV2 from "@/app/versioning/components/v2/CustomButton/CustomButtonV2";
import CustomFooter from "@/app/versioning/components/v2/FooterV2/CustomFooter";
import HTMLReactParser from "html-react-parser/lib/index";
import { useRouter } from "next/navigation";
import { useTranslation } from "react-i18next";
import { FiEye, FiEyeOff } from "react-icons/fi";
import { IoArrowForward } from "react-icons/io5";
import { MdOutlineEmail } from "react-icons/md";
import ErrorMessageV2 from "./error-message-v2";
import { InputTextBoxV2 } from "./InputTextBoxV2";
import { handleKeyDown } from "./login-utils";
import SpinnerLoaderV2 from "./spinner-loader-v2";

export const LoginForm = ({
  placeHolderText,
  loginForm,
  buttonRef,
  handleDivClick,
  isLoading,
  setShowPassword,
  showPassword,
}: {
  placeHolderText: string;
  loginForm: any;
  buttonRef: any;
  handleDivClick: Function;
  isLoading: boolean;
  setShowPassword: Function;
  showPassword: boolean;
}) => {
  const {
    values,
    handleBlur,
    handleChange,
    submitForm,
    touched,
    errors,
    isValid,
  } = loginForm;
  const { t } = useTranslation();
  const router = useRouter();
  const { isChecked, setIsChecked } = useTncCheckbox();

  return (
    <>
      <div className="login-form-container">
        <div className="container-information">
          <h2 className="container-title">{t("registerLogin.welcomeBack")}</h2>
          <p className="container-subtitle">
            {HTMLReactParser(t("loginV2.loginSubheading"))}
          </p>
        </div>
        {/* {children} */}
        <div className="form-fields-contaienr">
          <div className="email-username-container">
            <InputTextBoxV2
              mainClassName={"custom-input-light-mode"}
              hint={placeHolderText}
              onChange={(e: any) => {
                //setShouldPasswordVisible(false);
                handleChange(e);
              }}
              onKeyPress={(e: any) => handleKeyDown(e, buttonRef)}
              isShowSuffix={true}
              suffix={<MdOutlineEmail className="icon-eye-v2" />}
              onBlur={handleBlur}
              name="email"
              maxLength={50}
              value={values.email}
              placeholder={t("common.email")}
              hasError={touched?.email != null && errors?.email != null}
            />
            <div style={{ marginTop: "3px" }}>
              <ErrorMessageV2
                message={touched?.email ? errors?.email ?? "" : undefined}
                touched={touched?.email}
              />
            </div>
          </div>

          <div className="password-container">
            <InputTextBoxV2
              mainClassName={"custom-input-light-mode"}
              hint={placeHolderText}
              onChange={handleChange}
              onBlur={handleBlur}
              name="password"
              value={values.password}
              placeholder={t("common.password")}
              hasError={touched?.password != null && errors?.password != null}
              type={showPassword ? "text" : "password"}
              onKeyPress={(e: any) => handleKeyDown(e, buttonRef)}
              autoComplete="off"
              isShowSuffix={true}
              suffix={
                showPassword ? (
                  <FiEyeOff
                    className="icon-eye-v2 cursor-pointer"
                    onClick={() => setShowPassword(false)}
                  />
                ) : (
                  <FiEye
                    className="icon-eye-v2 cursor-pointer"
                    onClick={() => setShowPassword(true)}
                  />
                )
              }
            />
            <div style={{ marginTop: "3px" }}>
              <ErrorMessageV2
                message={touched?.password ? errors?.password ?? "" : undefined}
                touched={touched?.password}
              />
            </div>
          </div>

          <button
            className="forgot-password-v2"
            onClick={() => {
              router.push(AppRoutes.forgotPassword);
            }}
          >
            {/* Forgot password? */}
            {t("registerLogin.forgotPassword")}
          </button>
          <div className="terms-button-alternate-account-container">
            <CustomFooter checked={isChecked} setChecked={setIsChecked} />
            <CustomButtonV2
              className="display_desktop"
              ref={buttonRef}
              disabled={!isChecked}
              style={{ marginBottom: "20px" }}
              fullWidth
              isLoading={isLoading}
              onClick={() => {
                if (!isLoading) handleDivClick(submitForm);
              }}
            >
              {t("common.continue")}
            </CustomButtonV2>
            <p className="text-sm text-gray cursor-pointer">
              {t("common.dontHaveAnAccount")}{" "}
              <a
                onClick={() => {
                  router.push(AppRoutes.register);
                }}
                className="text-orange font-semibold hover:underline"
              >
                {t("common.signUp")}
              </a>
            </p>
          </div>
        </div>
      </div>
      <button
        ref={buttonRef}
        disabled={!isValid && !isChecked}
        className={`login-btn-v2 display_mobile ${
          !isValid || !isChecked ? "inactive" : ""
        }`}
        onClick={() => {
          if (isValid && isChecked) {
            if (!isLoading) handleDivClick(submitForm);
          }
        }}
      >
        {!isLoading ? (
          <IoArrowForward
            color={
              isValid && isChecked ? "var(--base-white)" : "var(--sub-heading3)"
            }
          />
        ) : (
          <SpinnerLoaderV2 />
        )}
      </button>
    </>
  );
};
